import DialogContent from "@mui/material/DialogContent";

export default DialogContent;
